import React, { Component } from 'react';
import { connect } from 'react-redux';

import { getPaymentType, updatePaymentType } from '../actions/PaymentTypeActions';

import { Pane, Heading, Button } from 'evergreen-ui';
import InfoBlock from '../../common/InfoBlock/InfoBlock';

import { Link } from 'react-router-dom';
import PaymentTypeForm from '../components/PaymentTypeForm';

import Configuration from '../Config';

const validation = Configuration.Validations.paymentType;
const mapValidationErrors = Configuration.ErrorHandler.mapValidationErrors;

class EditPaymentType extends Component {
    constructor(props) {
        super(props);

        this.id = this.props.params.id;
    }
    componentDidMount() {
        this.props.dispatch(getPaymentType(this.id));
    }

    handleSave = (values) => {
        this.props.dispatch(updatePaymentType(this.props.paymentType.id, values));
    }

    render() {
        return (
            <Pane padding={16} paddingTop={0}>
                <Pane display="flex">
                    <Pane>
                        <Link to="/payment-types">
                            <Button iconBefore="arrow-left" intent="none">
                                Inapoi la lista modalitati de plata
                            </Button>
                        </Link>
                    </Pane>
                    
                    <Pane marginLeft={16}>
                        <Link to={`/payment-types/${this.id}`}>
                            <Button iconBefore="cross" intent="warning">
                                Anuleaza modificarile
                            </Button>
                        </Link>
                    </Pane>
                </Pane>

                <Pane flex={1} background="tint1" elevation={1} padding={16} marginTop={16}>
                    <Heading size={600}>
                        Modificare Modalitate de plata - <strong>{this.props.paymentType.name}</strong>
                    </Heading>
                </Pane>
                
                <Pane display="flex" justifyContent="space-between" flex={1} marginTop={16}>
                    <InfoBlock flex="1">
                        <PaymentTypeForm 
                            isEdit={true}
                            initialValues={this.props.paymentType}
                            validationSchema={validation}
                            onSave={this.handleSave}
                            errors={this.props.errors}/>
                    </InfoBlock>
                </Pane>
            </Pane>
        )
    }
}

function mapStateToProps(state) {
    return {
        errors: state.paymentTypes.errors.type === 'validation' ? mapValidationErrors(state.paymentTypes.errors.fields): [],
        paymentType: state.paymentTypes.current
    }
}

export default connect(mapStateToProps)(EditPaymentType);